import { FFResponse } from '../interfaces/network';
import { requestJson } from '@vfde-sails/utils';
import { Domains, Endpoints } from '../enums/network';
import { LmsFormDTO, LmsResponse } from '../container/LeadManagementForm/interface';
import { getUrl } from './url';

const postOptions: RequestInit = {
    headers: [ ['Content-Type', 'application/json'] ],
    method: 'POST',
};
/**
 * validateFriendsAndFamily
 * @param token
 * @returns FFResponse
 */
export const validateFriendsAndFamily = async (token: string): Promise<FFResponse> => {
    const url = getUrl(Domains.ZUHAUSEPLUS, Endpoints.FF, { ffv2: token });

    const { body } = await requestJson<FFResponse>(url, postOptions);

    if (!body || 'valid' !== body.ffv2.state) {
        throw new Error('invalid ffv2 token');
    }

    return body;
};

export const postLmFrom = async (payload: LmsFormDTO): Promise<LmsResponse | null> => {
    const url = getUrl(Domains.ZUHAUSEPLUS, Endpoints.LMS);

    const { body } = await requestJson<LmsResponse>(url, {
        ...postOptions,
        body: JSON.stringify(payload),
    });

    return body;
};
